module.exports = {
      id: "time-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "assets/sprite-28816f.svg#time-usage",
      toString: function () {
        return this.url;
      }
    }